import { Field, useField } from "formik";
import React from "react";
import FormField from "./FormField";

const SelectField = ({
  name,
  label,
  options,
  defaultText = "Select",
  ...rest
}) => {
  const [field, meta] = useField(name);

  return (
    <FormField label={label} name={name}>
      <Field
        as="select"
        name={name}
        className={`w-full p-4 border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent ${
          field.value === "" ? "text-[#afb6b9]" : ""
        } ${meta.touched && meta.error ? "border-red-500" : "border-dark-gray/50"}`}
        {...rest}
      >
        <option value="">{defaultText}</option>
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </Field>
    </FormField>
  );
};

export default SelectField;
